module.exports = __webpack_public_path__ + "static/06-a12a798d445eab859bdd8a2207e93f70.png";